export default {
      id: "ic-para-cellphone-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-cellphone-usage",
      toString: function () {
        return this.url;
      }
    }